'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface Tab {
  label: string
  href: string
}

export function ExchangeTabs({ tabs }: { tabs: Tab[] }) {
  const pathname = usePathname()

  return (
    <div className="flex items-center border border-zinc-800 w-fit mb-8 max-w-full overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {tabs.map((tab, i) => {
        const isActive = pathname === tab.href
        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={`px-5 py-2.5 text-xs lg:text-sm font-medium whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-zinc-800 text-white'
                : 'text-zinc-400 hover:text-white hover:bg-zinc-900'
            } ${i > 0 ? 'border-l border-zinc-800' : ''}`}
          >
            {tab.label}
          </Link>
        )
      })}
    </div>
  )
}